export default __webpack_public_path__ + "img/img_anna_chang-bde183f6ba0e5a9b2523b6eac3fec069.jpg";